import React from 'react';
import { Link } from 'react-router-dom';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
  onLogout?: () => void | Promise<void>;
  isLoggedIn?: boolean;
  userName?: string;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ isOpen, onClose, onLogout, isLoggedIn = false, userName = '' }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] lg:hidden">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="absolute left-0 top-0 h-full w-full sm:w-[360px] bg-gradient-to-b from-[#0e2039] to-[#27599f]">
        <div className="flex h-14 items-center px-4">
          <button onClick={onClose} className="h-6 w-6">
            <div className="relative h-full w-full">
              <div className="absolute left-[4.5px] top-[4.5px] h-[15px] w-[15px]">
                <div className="absolute h-[2px] w-[15px] bg-white rotate-45 top-[6.5px]" />
                <div className="absolute h-[2px] w-[15px] bg-white -rotate-45 top-[6.5px]" />
              </div>
            </div>
          </button>
          <h1 className="ml-4 text-base font-extrabold text-white">부산항신항시설관리센터</h1>
        </div>

        <div className="h-px w-full bg-[#e2e2e2]/5" />
        
        <div className="mt-8 px-[30px]">
          <div className="flex flex-col gap-5">
            <button onClick={onClose} className="flex justify-between items-center text-lg font-semibold text-white w-full text-left">
              <span>홈</span>
              <span className="text-white">→</span>
            </button>
            <Link to="/guide" className="flex justify-between items-center text-lg font-semibold text-white">
              <span>이용안내</span>
              <span className="text-white">→</span>
            </Link>
            <Link to="/facility" className="flex justify-between items-center text-lg font-semibold text-white">
              <span>시설예약</span>
              <span className="text-white">→</span>
            </Link>
            <Link to="/portville" className="flex justify-between items-center text-lg font-semibold text-white">
              <span>포트빌 대기</span>
              <span className="text-white">→</span>
            </Link>
            <Link to="/notices" className="flex justify-between items-center text-lg font-semibold text-white">
              <span>공지사항</span>
              <span className="text-white">→</span>
            </Link>
          </div>
        </div>

        <div className="mt-10 px-[30px]">
          {isLoggedIn ? (
            <div className="flex flex-col gap-4">
              <div className="flex justify-between items-center text-lg font-semibold text-white">
                <span>{userName} 님</span>
              </div>
              <div className="flex flex-col gap-3">
                <Link
                  to="/settings"
                  onClick={onClose}
                  className="flex justify-between items-center text-base font-semibold text-white/90"
                >
                  <span>설정</span>
                  <span className="text-white/90">→</span>
                </Link>
                <button
                  type="button"
                  onClick={async () => {
                    onClose();
                    await onLogout?.();
                  }}
                  className="flex justify-between items-center text-base font-semibold text-white/90 w-full text-left"
                >
                  <span>로그아웃</span>
                  <span className="text-white/90">→</span>
                </button>
              </div>
            </div>
          ) : (
            <Link to="/signin" className="flex justify-between items-center text-lg font-semibold text-white">
              <span>로그인</span>
              <span className="text-white">→</span>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileMenu; 
